export function delay(duration: number): Promise<void> {
  if (!duration) return Promise.resolve();

  return new Promise((resolve) => setTimeout(resolve, duration));
}
